// @ts-ignore
import styles from './Text.module.scss';
import { useAppContext } from '../../../Services/AppContext';
import FirstUpper from '../../FirstUpper';
import React, { ReactNode } from 'react';
import NoEscape from '../../NoEscape';

interface TextProps {
	tx?: string;
	className?: string;
	style?: any;
	inline?: boolean;
	firstUpper?: boolean;
	children?: string | React.ReactChild | React.ReactChild[];
	truncate?: number;
	colon?: boolean;
	noEscape?: boolean;
}

const Text: React.FC<TextProps> = props => {
	const { className, style, inline, firstUpper, children, truncate, noEscape, colon } =
		props;
	let { tx = '' } = props;
	const { translation } = useAppContext();

	const classes = `${className || ''} ${styles.p}`;

	if (children) {
		if (typeof children !== 'string') {
			return (
				<>
					{React.Children.map(children, child => {
						if (React.isValidElement(child)) {
							return React.cloneElement(child);
						}
						return child;
					})}
				</>
			);
		} else {
			tx = children;
		}
	}

	tx = translation[tx] || tx;

	if (truncate) {
		tx = truncateString(tx || '', truncate);
	}

	if (colon) {
		tx += ':';
	}

	let txElement: string | ReactNode;

	if (firstUpper) {
		txElement = <FirstUpper>{tx}</FirstUpper>;
	} else {
		txElement = tx;
	}

	let component = undefined;

	if (inline) {
		component = (
			<span className={classes} style={style}>
				{txElement}
			</span>
		);
	} else {
		component = (
			<p className={classes} style={style}>
				{txElement}
			</p>
		);
	}

	if (noEscape) {
		// @ts-ignore
		component = <NoEscape>{txElement?.props?.children}</NoEscape>;
	}

	return component;
};

function truncateString(text: string, maxLen: number) {
	if (text.length <= maxLen) {
		return text;
	}
	return text.slice(0, maxLen) + '...';
}

export default Text;
